import styled from 'styled-components'

export const Container = styled.div``

export const ContainerSelect = styled.div<{ mask?: 'dark' | 'light' }>`
  min-width: 200px;
  background-color: ${({ mask }) => (mask == 'dark' ? '#3e3d40' : 'var(--background-elevation-overlay, #FFF)')};
  border-radius: 8px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07), 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
  box-sizing: border-box;
  min-height: 36px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    width: 100vw;
  }
`

export const Section = styled.div``

export const SectionTitle = styled.div`
  padding: 8px 8px;
  box-sizing: border-box;

  color: var(--Text-Secondary, #4d5874);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */

  cursor: default;
`

export const Item = styled.div<{ disabled?: boolean; mask?: 'dark' | 'light' }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  border-radius: 4px;

  color: var(--Foreground-Neutral, var(--Foreground-Neutral, #14171f));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  &:hover {
    background: var(--Background-Neutral, #dfe2ea66);
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const LabelContainer = styled.div``

export const IconContainer = styled.div<{ flipIcon?: boolean; mask?: 'dark' | 'light' }>`
  margin-right: 10px;
  display: flex;
  align-items: center;
  transform: rotate(${({ flipIcon }) => (flipIcon ? 180 : 0)}deg);
  color: ${({ mask }) => (mask == 'dark' ? 'white' : 'black')};
`
